import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from './AuthenticationService';
import { AppConfig } from '../app.config';
import { AuctionAuthorizationRequest } from '../requests/auctionAuthorizationRequest';
import { CreatePaymentIntentStripeRequest } from '../requests/stripe/createPaymentIntentStripeRequest';
import { BasicResponse } from '../responses/basicResponse';
import { LinkTokenResponse } from '../responses/plaid/linkTokenResponse';
import { CreatePaymentIntentPaypalRequest } from '../requests/paypal/createPaymentIntentPaypalRequest';
import { LinkTokenRequest } from '../requests/plaid/linkTokenRequest';
import { PublicTokenExchangeRequest } from '../requests/plaid/publicTokenExchangeRequest';
import { AuctionPaymentRequest } from '../requests/auctionPaymentRequest';
import { LoggingService } from './LoggingService';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationApiService {
  
 
  constructor(private httpClient: HttpClient, private appConfig:AppConfig, private authService:AuthenticationService, private logger:LoggingService) { 
  }
  get businessId():string{
    return this.appConfig.businessId;
  }
  get serviceURL():string {
    return this.appConfig.getConfig("authorizationapi_external_url") + '/';
  }
  get optionsJson(){
    return this.appConfig.optionsJson;
  }
  get optionsForm(){
    return this.appConfig.optionsForm;
  }

  //#region stripe
  public createPaymentIntentStripe(request:CreatePaymentIntentStripeRequest):Observable<any>{
    request.userId=this.authService.currentUserValue!.id;
    this.logger.log("createPaymentIntent:", request);
    return this.httpClient.post<any>(this.serviceURL+`stripe/createPaymentIntent`, request, this.optionsJson).pipe(catchError((error: any):any => {this.handleError(error); return of (this.createBasicResponseError(error))}));
  }

  public authorizeForAuctionStripe(request:AuctionAuthorizationRequest):Observable<any>{
    request.userId=this.authService.currentUserValue!.id;
    this.logger.log("auctionAuthorization:", request);
    return this.httpClient.post<any>(this.serviceURL+`stripe/auctionAuthorization`, request, this.optionsJson).pipe(catchError((error: any):any => {this.handleError(error); return of (this.createBasicResponseError(error))}));
  }
  //#endregion

  //#region paypal
  public createPaymentIntentPaypal(request:CreatePaymentIntentPaypalRequest):Observable<any>{
    request.userId=this.authService.currentUserValue!.id;
    this.logger.log("createPaymentIntent:", request);
    return this.httpClient.post<any>(this.serviceURL+`paypal/createPaymentIntent`, request, this.optionsJson).pipe(catchError((error: any):any => {this.handleError(error); return of (this.createBasicResponseError(error))}));
  }

  public authorizeForAuctionPaypal(request:AuctionAuthorizationRequest):Observable<any>{
    request.userId=this.authService.currentUserValue!.id;
    this.logger.log("auctionAuthorization: " + request);
    return this.httpClient.post<any>(this.serviceURL+`paypal/auctionAuthorization`, request, this.optionsJson).pipe(catchError((error: any):any => {this.handleError(error); return of (this.createBasicResponseError(error))}));
  }
  //#endregion

  //#region plaid
  public createLinkTokenPlaid(userId:string, userEmail:string):Observable<LinkTokenResponse>{
    let request=new LinkTokenRequest();
    request.userId = userId;
    request.userEmail = userEmail;
    this.logger.log("getPlaidLinkToken: ", request);
    return this.httpClient.post<LinkTokenResponse>(this.serviceURL+`plaid/createLinkToken`, request, this.optionsJson).pipe(catchError((error: HttpErrorResponse) => {this.handleError(error); return of (Object.assign(new LinkTokenResponse(), this.createBasicResponseError(error)))}));
  }

  public exchangePublicTokenPlaid(userId:string, publicToken:string){
    let request=new PublicTokenExchangeRequest();
    request.userId = userId;
    request.publicToken = publicToken;
    this.logger.log("exchangePublicToken: ", request);
    return this.httpClient.post<any>(this.serviceURL+`plaid/exchangePublicToken`, request, this.optionsJson).pipe(catchError((error: any):any => {this.handleError(error); return of (this.createBasicResponseError(error))}));
  }

  public authorizeForAuctionPlaid(request:AuctionAuthorizationRequest):Observable<any>{
    request.userId=this.authService.currentUserValue!.id;
    this.logger.log("auctionAuthorization: ", request);
    return this.httpClient.post<any>(this.serviceURL+`plaid/auctionAuthorization`, request, this.optionsJson).pipe(catchError((error: any):any => {this.handleError(error); return of (this.createBasicResponseError(error))}));
  }
  public paymentForAuctionPlaid(request:AuctionPaymentRequest):Observable<any>{
    request.userId=this.authService.currentUserValue!.id;
    this.logger.log("auctionPayment: ", request);
    return this.httpClient.post<any>(this.serviceURL+`plaid/auctionPayment`, request, this.optionsJson).pipe(catchError((error: any):any => {this.handleError(error); return of (this.createBasicResponseError(error))}));
  }
  //#endregion

  //region auction authorizations
  public getUserAuctionAuthorizations(){
    this.logger.log("getUserAuctionAuthorizations");
    return this.httpClient.get<any>(this.serviceURL+`userAuctionAuthorizations/`+ this.authService.currentUserValue!.id, this.optionsJson).pipe(catchError((error: any):any => {this.handleError(error); return of (this.createBasicResponseError(error))}));
  }
  //#endregion

  private createBasicResponseError(error: HttpErrorResponse){
    let br = new BasicResponse();
    br.message=error.message;
    return br;
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
        // A client-side or network error occurred. Handle it accordingly.
        console.error('An error occurred:', error.error.message);
    } else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(()=>(error));
  }
}
